// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDcMjEtzyfHhaEVOs_5sie0iypdWT0vx7c",
  authDomain: "hygensolution-2696d.firebaseapp.com",
  projectId: "hygensolution-2696d",
  storageBucket: "hygensolution-2696d.firebasestorage.app",
  messagingSenderId: "961848097139",
  appId: "1:961848097139:web:596e36d7b5d5339e866d06",
  measurementId: "G-4673KSD1N2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { app, analytics };